import React from 'react';
import MDBox from 'components/MDBox';
import { StaffMobileCardItem } from './StaffMobileCardItem';

export function StaffAccordionList({ items, onDetail, onEdit, onOpenMenu }) {
  return (
    <MDBox sx={{ display: 'grid', gap: 1.2 }}>
      {(items || []).map((s) => (
        <StaffMobileCardItem
          key={s.id}
          staff={s}
          onOpenMenu={onOpenMenu}
          onDetail={onDetail}
          onEdit={onEdit}
        />
      ))}
    </MDBox>
  );
}
